/* eslint-disable react-hooks/exhaustive-deps */
import TableCellFilted from '../../common/componentUI/TableCellFilted';
import allUsersDispatcher from '../action';
import {
  ACTIVE_USERS_STATUS,
  ACTIVE_USERS_STATUS_COLORS,
  ACTIVE_USERS_STATUSES_FILTER,
  APPROVE_USERS_STATUS,
  COLUMN_ALL_USERS,
} from '../constants';
import GroupToolbar from './GroupToolbar';
import ModalAddDependentProfile from './ModalAddDependentProfile';
import {
  ActivateIcon,
  BanIcon,
  Checkmark2Icon,
  CloseCircle,
  CreateNewIcon,
  DeactivateIcon,
  DeleteModalIcon,
  EditIcon,
  ExportIcon,
  NoticeIcon,
  SignUpRequestIcon,
} from '@/assets/svg';
import { urlLabel } from '@/enum/PermissionEnum';
import { getNationalNumber, handleSelectAll, momentFormatted } from '@/helpers';
import { StatusComponent } from '@/module/all-screenings/component/StatusComponent';
import patientDispatcher from '@/module/patient/actions';
import CustomMenu from '@/new-components/CustomMenu';
import CustomMenuActions from '@/new-components/CustomMenuActions';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import customToast from '@/new-components/CustomNotification';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import { validateMobile } from '@/utils/validation';
import {
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Button,
  Drawer,
  withStyles,
  Box,
} from '@material-ui/core';
import { MoreVertRounded } from '@material-ui/icons';
import { parsePhoneNumber } from 'libphonenumber-js';
import { cloneDeep, debounce, isEmpty } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const CustomButton = withStyles({
  root: {
    width: 200,
    height: 48,
    borderRadius: '100px',

    fontSize: 18,
    fontWeight: 400,
    textTransform: 'unset',
    '&.red': {
      background: '#DB3D49',
    },
  },
  containedPrimary: {
    boxShadow: 'none',
  },
})(Button);

const AllUsers = () => {
  const { list, paging } = useSelector((state) => state.patient);
  const history = useHistory();

  const [searchKey, setSearchKey] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedItem, setSelectedItem] = useState({});
  const [selectedParentItem, setSelectedParentItem] = useState(null);
  const [sortOption, setSortOption] = useState({});

  const [activeStatuses, setActiveStatuses] = useState([]);

  const [filterOption, setFilterOption] = useState({});

  const [loading, setLoading] = useState(false);

  const [showDeleteUserModal, setDeleteShowUserModal] = useState(false);
  const [showActiveUserModal, setActiveUserModal] = useState(false);
  const [showPendingDependentModal, setPendingDependentModal] = useState(false);
  const [pendingDependentUser, setPendingDependentUser] = useState(null);

  const [showAddDependentProfileModal, setAddDependentProfileModal] =
    useState(false);
  const onShowAllUsers = () =>
    history.push({
      pathname: `/${urlLabel.editUserDetail}`,
      state: selectedItem,
    });

  const onFilterOptionChange = (key) => (e, newValue) => {
    let value = e.target.value;

    switch (key) {
      case 'activeStatuses':
        value = handleSelectAll(
          value,
          ACTIVE_USERS_STATUSES_FILTER.map((item) => item.key),
          activeStatuses
        );
        setActiveStatuses(value);
        break;

      default:
        break;
    }

    setFilterOption({
      ...filterOption,
      [key]: value,
    });
  };

  const onResetFilterOps = () => {
    setActiveStatuses([]);
  };

  const exportExcel = () => {
    if (list.length === 0) {
      return customToast(
        'info',
        'There is no data available to export the excel file'
      );
    }
    allUsersDispatcher.getExportExcel(searchKey);
  };

  const onDeleteUser = () => {
    if (selectedItem.isChild) {
      patientDispatcher.deleteDependentProfile(selectedItem.id, () => {
        setFilterOption(cloneDeep(filterOption));
      });
    } else {
      patientDispatcher.deletePatientUser(selectedItem.id, () => {
        setFilterOption(cloneDeep(filterOption));
      });
    }
    setDeleteShowUserModal(false);
  };

  const onActivateUser = () => {
    patientDispatcher.inActiveOrActivePatient(
      {
        userId: selectedItem.id,
        isActive: selectedItem.activeStatus === 'Active' ? false : true,
      },
      () => {
        fetchData(searchKey, paging, sortOption, filterOption);
        setActiveUserModal(false);
        customToast(
          'success',
          `${
            selectedItem.activeStatus === 'InActive' ? 'Activate' : 'Deactivate'
          } successfully`
        );
      }
    );
  };

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {COLUMN_ALL_USERS.map((item) => (
          <TableCellFilted
            colSpan={item.colSpan}
            key={item.stateValue}
            label={item.label}
            stateValue={item.stateValue}
            style={{
              minWidth: item.minWidth || 'unset',
              width: item.width || 'unset',
            }}
            isHidden={false}
          />
        ))}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = (row, isChild = false, parentRow = null) => {
    return (
      <>
        <TableCell>
          <CustomTooltip content={row.fullName || '—'} />
        </TableCell>
        <TableCell>
          {row.identityNumber ? (
            <Box display="flex" alignItems="center" gridGap={4}>
              {row.identityNumber}
              {row.hasPendingDependent ? (
                isChild ? (
                  <IconButton
                    onClick={() => {
                      allUsersDispatcher.getPendingDependentUser(
                        row.id,
                        (result) => {
                          setPendingDependentUser(result);
                        }
                      );
                      setPendingDependentModal(true);
                      setSelectedItem({ ...row, isChild });
                      setSelectedParentItem(parentRow);
                    }}
                  >
                    <NoticeIcon width={16} height={16} />
                  </IconButton>
                ) : (
                  <NoticeIcon width={16} height={16} />
                )
              ) : (
                ''
              )}
            </Box>
          ) : (
            '—'
          )}
        </TableCell>
        <TableCell>{row.isRegisterLv2 ? 2 : 1}</TableCell>

        <TableCell>
          <CustomTooltip content={row.email || '—'} />
        </TableCell>
        <TableCell>
          {row.mobile &&
          row?.countryCode &&
          validateMobile(row?.mobile, row?.countryCode)
            ? parsePhoneNumber(
                getNationalNumber(row?.mobile, row?.countryCode, true)
              ).formatInternational()
            : '—'}
        </TableCell>
        <TableCell>
          {row.dateOfBirth
            ? momentFormatted(row.dateOfBirth, 'DD/MM/YYYY')
            : '—'}
        </TableCell>
        <TableCell>{row.gender || '—'}</TableCell>
        <TableCell>
          <StatusComponent
            status={row.approveStatus}
            filterList={APPROVE_USERS_STATUS}
            filterListColor={ACTIVE_USERS_STATUS_COLORS}
          />
        </TableCell>
        <TableCell>
          <StatusComponent
            status={row.activeStatus}
            filterList={ACTIVE_USERS_STATUS}
            filterListColor={ACTIVE_USERS_STATUS_COLORS}
          />
        </TableCell>

        <TableCell>
          <IconButton
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setSelectedItem({ ...row, isChild });
              setSelectedParentItem(parentRow);
            }}
          >
            <MoreVertRounded />
          </IconButton>
        </TableCell>
      </>
    );
  };

  const renderListActions = useCallback(() => {
    const activeStatus = ACTIVE_USERS_STATUS[selectedItem.activeStatus];
    let listActions = [];

    switch (activeStatus) {
      case ACTIVE_USERS_STATUS.Active:
        if (selectedItem.isChild) {
          listActions = listActions.concat([
            {
              key: 'edit',
              icon: EditIcon,
              label: 'Details',
              styles: { width: 20, height: 20 },
              onClick: onShowAllUsers,
            },

            {
              key: 'deactivate',
              icon: BanIcon,
              label: 'Inactive User',
              color: '#DB3D49',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setActiveUserModal(true);
              },
            },
            {
              key: 'delete',
              icon: CloseCircle,
              label: 'Delete User',
              color: '#DB3D49',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setDeleteShowUserModal(true);
              },
            },
          ]);
        } else
          listActions = listActions.concat([
            {
              key: 'detail',
              icon: EditIcon,
              label: 'Details',
              styles: { width: 20, height: 20 },
              onClick: onShowAllUsers,
            },
            {
              key: 'add',
              icon: CreateNewIcon,
              label: 'Add dependent profile',
              onClick: () => {
                setAnchorEl(null);
                setAddDependentProfileModal(true);
              },
            },
            {
              key: 'deactivate',
              icon: BanIcon,
              label: 'Inactive User',
              color: '#DB3D49',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setActiveUserModal(true);
              },
            },
            {
              key: 'delete',
              icon: CloseCircle,
              label: 'Delete User',
              color: '#DB3D49',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setDeleteShowUserModal(true);
              },
            },
          ]);
        break;

      case ACTIVE_USERS_STATUS.InActive:
        if (selectedItem.isChild) {
          listActions = listActions.concat([
            {
              key: 'detail',
              icon: EditIcon,
              label: 'Details',
              styles: { width: 20, height: 20 },
              onClick: onShowAllUsers,
            },

            {
              key: 'activate',
              icon: Checkmark2Icon,
              label: 'Activate User',
              color: '#0B8E5E',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setActiveUserModal(true);
              },
            },
            {
              key: 'delete',
              icon: CloseCircle,
              label: 'Delete User',
              color: '#DB3D49',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setDeleteShowUserModal(true);
              },
            },
          ]);
        } else
          listActions = listActions.concat([
            {
              key: 'detail',
              icon: EditIcon,
              label: 'Details',
              styles: { width: 20, height: 20 },
              onClick: onShowAllUsers,
            },
            {
              key: 'add',
              icon: CreateNewIcon,
              label: 'Add dependent profile',
              onClick: () => {
                setAnchorEl(null);
                setAddDependentProfileModal(true);
              },
            },
            {
              key: 'activate',
              icon: Checkmark2Icon,
              label: 'Activate User',
              color: '#0B8E5E',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setActiveUserModal(true);
              },
            },
            {
              key: 'delete',
              icon: CloseCircle,
              label: 'Delete User',
              color: '#DB3D49',
              styles: { width: 18, height: 18 },
              onClick: () => {
                setAnchorEl(null);
                setSelectedItem(selectedItem);
                setDeleteShowUserModal(true);
              },
            },
          ]);
        break;
      default:
        break;
    }

    return listActions;
  }, [onShowAllUsers, selectedItem]);

  const fetchData = async (
    search = searchKey,
    pagingData = paging,
    sortOptionData = sortOption,
    filterOptionData = filterOption
  ) => {
    patientDispatcher.getPatientList(
      search,
      pagingData,
      ...[sortOptionData, filterOptionData].filter((i) => i)
    );
  };

  const debounceLoadData = useCallback(
    debounce((searchKey, paging, sortOption, filterOption) => {
      fetchData(
        searchKey,
        {
          pageIndex: 0,
          pageSize: paging.pageSize,
        },
        sortOption,
        filterOption
      );
    }, 500),
    []
  );

  useEffect(() => {
    debounceLoadData(searchKey, paging, sortOption, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey, sortOption, filterOption]);

  useEffect(() => {
    return () => {
      patientDispatcher.resetData();
    };
  }, []);

  const handleAddDependentProfile = (data) => {
    setLoading(true);
    patientDispatcher.createDependentProfile(
      data,
      () => {
        fetchData(searchKey, paging, sortOption, filterOption);
        customToast(
          'success',
          <>
            Dependent profile for patient{' '}
            <strong style={{ fontWeight: 600 }}>
              {selectedParentItem?.fullName}
            </strong>{' '}
            has been successully created.
          </>,
          'Add dependent profile'
        );
        setAddDependentProfileModal(false);
        setSelectedParentItem(null);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <>
      <CustomMenu
        id="simple-menu"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <CustomMenuActions listActions={renderListActions()} />
      </CustomMenu>
      <CustomPaperContainer
        header={
          <CustomHeader
            searchPlaceholder="Search by name or User ID, NRIC, Email, Mobile Number..."
            title="All Users"
            setSearchKey={setSearchKey}
            searchKey={searchKey}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            sortOption={sortOption}
            fetchData={fetchData}
            renderToolbar={() => (
              <GroupToolbar
                filterOption={filterOption}
                setFilterOption={setFilterOption}
                onFilterOptionChange={onFilterOptionChange}
                onResetFilterOps={onResetFilterOps}
                activeStatuses={activeStatuses}
              />
            )}
            renderButton={() => (
              <>
                <Button
                  color="primary"
                  variant="outlined"
                  startIcon={<ExportIcon width={20} height={20} />}
                  onClick={exportExcel}
                >
                  Export
                </Button>
              </>
            )}
          />
        }
      >
        <CustomTable
          data={list}
          paging={paging}
          header={TableHeader}
          renderRow={(row, i) => renderTableBody(row)}
          noDataHelperText="No users"
          noDataHelperSubText="Please come back at another time."
          totalCols={COLUMN_ALL_USERS.length}
          fetchData={fetchData}
          hasRowChild={true}
          renderRowChild={(row, i, parentRow) =>
            renderTableBody(row, true, parentRow)
          }
        />
      </CustomPaperContainer>
      {showDeleteUserModal && (
        <ModalConfirmation
          open={showDeleteUserModal}
          onClick={onDeleteUser}
          onClose={() => setDeleteShowUserModal(false)}
          mainContent={`Delete ${
            selectedItem.isChild ? 'Dependent Profile' : 'User'
          }`}
          subContent="Are you sure you want to delete this user?"
          cancelLabel="No"
          confirmLabel="Yes"
          Icon={<DeleteModalIcon />}
        />
      )}

      {showActiveUserModal && (
        <ModalConfirmation
          open={showActiveUserModal}
          onClick={onActivateUser}
          onClose={() => setActiveUserModal(false)}
          mainContent={`${
            selectedItem.activeStatus === ACTIVE_USERS_STATUS.Active
              ? 'Deactivate'
              : 'Activate'
          } User`}
          subContent={`Are you sure you want to ${
            selectedItem.activeStatus === ACTIVE_USERS_STATUS.Active
              ? 'deactivate'
              : 'activate'
          } this user?`}
          cancelLabel="Cancel"
          confirmLabel={
            selectedItem.activeStatus === ACTIVE_USERS_STATUS.Active
              ? 'Deactivate'
              : 'Activate'
          }
          Icon={
            selectedItem.activeStatus === ACTIVE_USERS_STATUS.Active ? (
              <DeactivateIcon />
            ) : (
              <ActivateIcon />
            )
          }
        />
      )}

      {showPendingDependentModal && (
        <ModalConfirmation
          style={{
            padding: 20,
          }}
          maxWidth="sm"
          btnWidth={'200px'}
          open={showPendingDependentModal}
          onClose={() => setPendingDependentModal(false)}
          mainContent="Dependant Sign-Up Request"
          subContent={`User ${
            pendingDependentUser?.mobile
              ? `(mobile ending with ${pendingDependentUser?.mobile?.slice(
                  -4
                )})`
              : ''
          } has requested to sign up separately using NRIC ending with ${pendingDependentUser?.identityNumber?.slice(
            -4
          )}.`}
          subContent2={
            <>
              Do you approve this request to separate from{' '}
              <b>
                {selectedItem.isChild
                  ? selectedParentItem.fullName
                  : selectedItem.fullName}
              </b>
              's family group?
            </>
          }
          cancelLabel="Reject"
          confirmLabel="Approve"
          Icon={<SignUpRequestIcon />}
          otherActionsContent={() => (
            <>
              <CustomButton
                onClick={() => {
                  allUsersDispatcher.disapproveDependentProfile(
                    selectedItem.id,
                    () => {
                      setPendingDependentModal(false);
                      fetchData(searchKey, paging, sortOption, filterOption);
                      customToast(
                        'error',
                        <>
                          Dependant Sign-Up Request for patient{' '}
                          <strong style={{ fontWeight: 600 }}>
                            {selectedItem?.fullName}
                          </strong>{' '}
                          has been rejected.
                        </>,
                        'Dependant Sign-Up Request'
                      );
                    }
                  );
                }}
                variant="outlined"
                color="primary"
              >
                Reject
              </CustomButton>
              <CustomButton
                onClick={() => {
                  allUsersDispatcher.approveDependentProfile(
                    selectedItem.id,
                    () => {
                      setPendingDependentModal(false);
                      fetchData(searchKey, paging, sortOption, filterOption);
                      customToast(
                        'success',
                        <>
                          Dependant Sign-Up Request for patient{' '}
                          <strong style={{ fontWeight: 600 }}>
                            {selectedItem?.fullName}
                          </strong>{' '}
                          has been successully approved.
                        </>,
                        'Dependant Sign-Up Request'
                      );
                    }
                  );
                }}
                variant="contained"
                color="primary"
              >
                Approve
              </CustomButton>
            </>
          )}
        />
      )}
      <Drawer
        anchor="right"
        open={showAddDependentProfileModal}
        onClose={() => setAddDependentProfileModal(false)}
        disableBackdropClick
        PaperProps={{
          style: {
            width: '80%',
            minWidth: 720,
          },
        }}
      >
        <ModalAddDependentProfile
          loading={loading}
          onSubmit={handleAddDependentProfile}
          selectedItem={selectedItem}
          onClose={() => setAddDependentProfileModal(false)}
        />
      </Drawer>
    </>
  );
};

export default AllUsers;
